import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { ToastProvider } from './components/Toast'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Sources from './pages/Sources'
import Authors from './pages/Authors'
import Images from './pages/Images'
import Queue from './pages/Queue'
import Quality from './pages/Quality'
import Categories from './pages/Categories'
import StorageMonitor from './pages/StorageMonitor'
import SystemMonitor from './pages/SystemMonitor'
import TestDashboard from './pages/TestDashboard'
import GameMonitor from './pages/GameMonitor'
import ErrorLogs from './pages/ErrorLogs'
import UserUploads from './pages/UserUploads'
import WebmasterAudit from './pages/WebmasterAudit'

function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin text-4xl mb-4">⏳</div>
          <p className="opacity-50">Загрузка...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

function AppRoutes() {
  const { isAuthenticated } = useAuth()

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="sources" element={<Sources />} />
        <Route path="authors" element={<Authors />} />
        <Route path="images" element={<Images />} />
        <Route path="categories" element={<Categories />} />
        <Route path="quality" element={<Quality />} />
        <Route path="uploads" element={<UserUploads />} />
        <Route path="queue" element={<Queue />} />
        <Route path="webmaster-audit" element={<WebmasterAudit />} />
        <Route path="system" element={<SystemMonitor />} />
        <Route path="storage" element={<StorageMonitor />} />
        <Route path="tests" element={<TestDashboard />} />
        <Route path="game" element={<GameMonitor />} />
        <Route path="errors" element={<ErrorLogs />} />
      </Route>
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  )
}

export default App
